import { PARTY_IDLE_TIMEOUT_MS } from '@mixwire/contracts';

import type { PartySlug } from '@mixwire/contracts';

const IDLE_TIMEOUT_MINUTES = String(Math.round(PARTY_IDLE_TIMEOUT_MS / 60_000));

/** The one sentence about who called the night over, said the same way wherever it appears. */
export const endedByLine = (endedBy: string | null): string =>
  endedBy === null
    ? `Nothing played anywhere for ${IDLE_TIMEOUT_MINUTES} minutes, so MixWire called it.`
    : `${endedBy} ended it for everyone.`;

const key = (slug: PartySlug): string => `mixwire-ended-by-me:${slug}`;

/**
 * The End button sends the DJ who pressed it to that party's public view, and
 * this carries the "I just did that" across that one navigation so they are not
 * told what they just did. It is deliberately short-lived: a DJ who comes back
 * to the same party later is told the party ended like anyone else.
 */
const HANDOVER_WINDOW_MS = 5000;

export const noteEndedByMe = (slug: PartySlug): void => {
  sessionStorage.setItem(key(slug), String(Date.now()));
};

export const wasJustEndedByMe = (slug: PartySlug): boolean => {
  const noted = sessionStorage.getItem(key(slug));
  if (noted === null) {
    return false;
  }

  if (Date.now() - Number(noted) <= HANDOVER_WINDOW_MS) {
    return true;
  }

  sessionStorage.removeItem(key(slug));
  return false;
};
